/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { action } from "@ember/object";
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import NavigationService from "core/services/navigation";
import SemeiaSessionService from "core/services/session";
import Ember from "ember";

// tells Tailwind that h-[50px] must be part of wiser.css;
const navbarHeightStyle = "h-[50px]";
export function navbarHeight() {
  return navbarHeightStyle.match(/\d+/)[0];
}
const firstLevelPages = ["medics-web.protected.index.alerts-and-notifications", "medics-web.protected.index.alerts-and-notifications_loading", "medics-web.protected.index.tasks-and-consultations", "medics-web.protected.index.tasks-and-consultations_loading", "medics-web.protected.index.patient-list", "medics-web.protected.index.patient-list_loading", "patient-web.protected_loading", "patient-web.protected.dashboard.index"];
const secondLevelPages = ["medics-web.protected.patients.patient.dashboard.main", "medics-web.protected.patients.patient.dashboard.main.index", "medics-web.protected.patients.patient.dashboard.bio-results.summary", "medics-web.protected.medics", "patient-web.protected.blood-pressure.sessions.index"];
const returnToMedicsWebDashboardPages = ["medics-web.protected.patients.patient.feature.component.index", "medics-web.protected.patients.patient.feature.component.edition", "medics-web.protected.patients.patient.form", "medics-web.protected.patients.patient.administrative.index"];
let NavBar = (_class = class NavBar extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "navigation", _descriptor2, this);
    _initializerDefineProperty(this, "store", _descriptor3, this);
    _initializerDefineProperty(this, "router", _descriptor4, this);
    _defineProperty(this, "navbarHeightStyle", navbarHeightStyle);
    _defineProperty(this, "menuStyles", `ui top menu no-print fixed !min-h-[0px] bg-pink [box-shadow:none] ${navbarHeightStyle}`);
    _defineProperty(this, "titleItemSytles", "grow-[2] text-center !font-bold [@media_screen_and_(max-width:549px)]:m-0");
  }
  get rootRoute() {
    if (this.session.medic) {
      if (this.isOnFirstLevelPage) return this.router.currentRouteName;
      return "medics-web.protected.index";
    } else if (this.session.patient) {
      return "patient-web.protected.dashboard.index";
    }
    return "index";
  }
  get isOnFirstLevelPage() {
    // Is there a better way of determining what route we end up on
    // after transitioning to 'index'?
    return firstLevelPages.includes(this.navigation.currentRouteName);
  }
  get shouldShowBack() {
    if (this.isOnSecondLevelPage) return false;
    return this.navigation.canGoBack;
  }
  get isOnSecondLevelPage() {
    return secondLevelPages.includes(this.navigation.currentRouteName);
  }
  get shouldReturnToMedicsWebDashboard() {
    return returnToMedicsWebDashboardPages.includes(this.navigation.currentRouteName);
  }
  get _testMode() {
    return Ember.testing;
  }
  back() {
    if (this.shouldReturnToMedicsWebDashboard) {
      this.router.transitionTo("medics-web.protected.patients.patient.dashboard");
    } else {
      this.navigation.back();
    }
  }
  get patients() {
    return this.store.peekAll("patient");
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "navigation", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "back", [action], Object.getOwnPropertyDescriptor(_class.prototype, "back"), _class.prototype), _class);
export { NavBar as default };